export enum MOBILITY {
	Lte10Km = 0,
	Lte30Km = 1,
	Lte50Km = 2,
	Gte50Km = 3,
}
